import OutageBannerWithData from './OutageBannerWithData'
import OutageBannerWithoutData from './OutageBannerWithoutData'

export default OutageBannerWithData
export { OutageBannerWithoutData }
